import useDataGridStore from "stores/dataGridStore";
import useMetadataStore from "stores/metadataStore";

const useDataGridLoading = () => {
  const { dataSourceIsLoading, updateDataSourceIsLoading } = useDataGridStore();
  const {isloading: metaDataIsLoading} = useMetadataStore();
  return { dataGridIsLoading: dataSourceIsLoading || metaDataIsLoading || updateDataSourceIsLoading}
}

export default useDataGridLoading;